module.exports = __webpack_public_path__ + "img/ad-04.ee563634.png";